import { BaseApiService } from '../../common/services/baseApiService';
import { API_URL } from '../../common/utils/util';
import { EpisodiosErp, SaludErp } from '../types/erp.types';

export class ErpService extends BaseApiService {
  /**
   * Estado del MySQL de Proscai. NO se cachea en el backend: es un signo vital
   * y un dato de hace una hora no sirve para decidir nada.
   */
  static async getSalud(): Promise<SaludErp> {
    try {
      const response = await fetch(`${API_URL}/dashboard/erp-salud`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      return await this.handleResponse<SaludErp>(response);
    } catch (error) {
      console.error('Get salud ERP error:', error);
      throw error;
    }
  }

  /**
   * Trabones recientes: lo que guardó el muestreador de 30 s cuando el ERP
   * estaba degradado. Lee sólo Postgres en el backend; no toca el ERP.
   */
  static async getEpisodios(desde?: string, hasta?: string): Promise<EpisodiosErp> {
    const q = new URLSearchParams();
    if (desde) q.set('desde', desde);
    if (hasta) q.set('hasta', hasta);
    const qs = q.toString();
    try {
      const response = await fetch(
        `${API_URL}/dashboard/erp-salud/episodios${qs ? `?${qs}` : ''}`,
        { method: 'GET', headers: this.getAuthHeaders() },
      );
      return await this.handleResponse<EpisodiosErp>(response);
    } catch (error) {
      console.error('Get episodios ERP error:', error);
      throw error;
    }
  }
}
